import { MutableRefObject } from "react";
import { useMutation } from "@tanstack/react-query";
import { INTEGRATION_LABELS, TEST_CONNECTION_MAP } from "../consts";
import { show } from "../../../notifications/notifications";
import { NotificationsLevel } from "../../../lib/enums";
import { ErrorResponse } from "../../../requests/@types";
import { TestConnectionErrorData } from "../@types/errors";

type TestConnectionMapKey = keyof typeof TEST_CONNECTION_MAP;

const useIntegrationConnectionStatus = (
  connectionStatus: MutableRefObject<boolean>
) => {
  const { mutateAsync: checkIntegrationConnection } = useMutation({
    mutationFn: (toolName: string) => {
      const checkConnectionFunction =
        TEST_CONNECTION_MAP[toolName as TestConnectionMapKey];
      return checkConnectionFunction();
    },
    onSuccess: () => {
      connectionStatus.current = true;
    },
    onError: (error: ErrorResponse<TestConnectionErrorData>, toolName) => {
      const { detail: validationErrorData } = error.data || {};
      if (validationErrorData.api) {
        connectionStatus.current = false;
      }
      show({
        level: NotificationsLevel.ERROR,
        message: `${
          INTEGRATION_LABELS[toolName as keyof typeof INTEGRATION_LABELS]
        } is currently unavailable. Try again in a few minutes or check with your admin if the integration is correctly configured.`
      });
    }
  });

  return { checkIntegrationConnection };
};

export default useIntegrationConnectionStatus;
